import React from "react";

export default function WebsiteCrmLinking() {
  const fakeData = Array.from({ length: 15 }).map((_, i) => ({
    id: i + 1,
    name: `User ${i + 1}`,
    email: `user${i + 1}@example.com`,
    phone: `+12345678${i}`,
    company: `Company ${i + 1}`,
    status: i % 2 === 0 ? "Active" : "Inactive",
  }));

  return (
    <>
      <div className="flex justify-between items-center ">
        <div>
          <p className="text-[32px] font-semibold text-black font-inter">
            Website & CRM Linking
          </p>
        </div>
      </div>
      <div className="my-8 p-4 border border-[#E5E7E7] rounded-2xl relative overflow-hidden max-h-[620px]">
        <div className="flex flex-col items-center justify-center p-4">
          <table className="w-full text-left border-collapse blur-sm">
            <thead>
              <tr className="text-gray-600 text-sm">
                <th className="px-4 py-2">ID</th>
                <th className="px-4 py-2">Name</th>
                <th className="px-4 py-2">Email</th>
                <th className="px-4 py-2">Phone</th>
                <th className="px-4 py-2">Company</th>
                <th className="px-4 py-2">Status</th>
              </tr>
            </thead>
            <tbody>
              {fakeData.map((row, i) => (
                <tr key={i} className="text-gray-800">
                  <td className="px-4 py-2">{row.id}</td>
                  <td className="px-4 py-2">{row.name}</td>
                  <td className="px-4 py-2">{row.email}</td>
                  <td className="px-4 py-2">{row.phone}</td>
                  <td className="px-4 py-2">{row.company}</td>
                  <td className="px-4 py-2 text-blue-500">{row.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Overlayed Coming Soon */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h1
            className=" font-black text-[56px] leading-[100%] tracking-[0] 
                px-10 py-6 rounded-2xl  text-center"
          >
            Coming Soon
          </h1>
        </div>

      </div>
    </>
  );
}
